import { IApplicationState } from '../../types/redux';

export const selectPageState = (state: IApplicationState) => {
  return state.pageState.state;
};
